var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreyChevronDown = function SvgGreyChevronDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79265 9.79912C6.18317 9.40859 6.81634 9.40859 7.20686 9.79912L12.4998 15.092L17.7926 9.79912C18.1832 9.4086 18.8163 9.4086 19.2069 9.79912C19.5974 10.1896 19.5974 10.8228 19.2069 11.2133L13.2069 17.2133C12.8163 17.6039 12.1832 17.6039 11.7926 17.2133L5.79265 11.2133C5.40212 10.8228 5.40212 10.1896 5.79265 9.79912Z",
    fill: "#E0E2E3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreyChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grey-chevron-down.44baf63756df1f4d7c66f20c203fe520.svg";